import { StudentMenu, Student } from '@/plugins/api'
import { has, max } from 'lodash'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    // Biến lưu mealReport đang hiển thị trên data table
    mealReports: [],
    // Chi tiết meal report tất cả các ngày trong 1 tháng của 1 học sinh
    detailStudentMealReportByMonth: [],
    // ============================
    // Data table query variables
    /**
     * Bộ lọc student theo :
     * Grade ID
     * currentClass ID
     * student ID
     */
    studentSearchParams: {},
    // Tổng số học sinh load được theo bộ lọc student
    // Dùng để hiện thị tổng số học sinh trên data table
    studentCount: 0,
    /**
     * Bộ lọc student menu collection theo :
     * Date
     */
    studentMenuSearchParams: {},
    // Default itemsPerPage
    itemsPerPage: 10,
    loading: false
  },
  actions: {
    async getStudentMealReportIndependent({ state }) {
      const res = await StudentMenu.getStudentMealReportByMonth({ ...state.studentMenuSearchParams, _limit: -1, _start: 0 })
      return res
    },
    async searchStudentMealReports({ commit, dispatch }, query) {
      const studentSearchParams = {
        status: query.status,
        currentClass: query.class,
        grade: query.grade,
        id: query.student,
        _limit: -1,
        _sort: 'nameToNumber:asc'
      }
      commit('setStudentSearchParams', studentSearchParams)
      if (has(query, 'date') && moment(query.date).isValid()) {
        const timeGte = moment(query.date).startOf('month')
        const timeLte = moment(query.date).endOf('month')
        const studentMenuSearchParams = {
          ...query,
          time: timeGte.toISOString(),
          time_gte: timeGte.toISOString(),
          time_lte: timeLte.toISOString()
        }
        commit('setStudentMenuSearchParams', studentMenuSearchParams)
      } else {
        commit('setStudentMenuSearchParams', {})
      }
      dispatch('requestPageSettings', {})
    },
    async requestPageSettings({ state, commit }, { page, itemsPerPage }) {
      commit('setLoading', true)
      commit('setMealReports', [])
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      commit('changeState', { itemsPerPage })

      const pageSettingParams = {
        _start: (page - 1) * itemsPerPage,
        _limit: itemsPerPage
      }
      if (!has(state.studentMenuSearchParams, 'date')) {
        return
      }
      const [studentCount, mealReports] = await Promise.all([
        Student.count(state.studentSearchParams),
        StudentMenu.getStudentMealReportByMonth({ ...state.studentMenuSearchParams, ...pageSettingParams })
      ])
      commit('setStudentCount', studentCount)
      commit('setMealReports', mealReports)
      commit('setLoading', false)
    },
    async getDetailStudentMealReportByMonth({ commit }, query) {
      commit('setLoading', true)
      commit('setDetailStudentMealReportByMonth', [])
      let data = await StudentMenu.getStudentMealReportByDate(query)
      commit('setDetailStudentMealReportByMonth', data)
      commit('setLoading', false)
    }
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading
    },
    setStudentSearchParams(state, params) {
      state.studentSearchParams = params
    },
    setStudentMenuSearchParams(state, params) {
      state.studentMenuSearchParams = params
    },
    setStudentCount(state, count) {
      state.studentCount = count
    },
    setMealReports(state, data) {
      state.mealReports = [...data]
    },
    setDetailStudentMealReportByMonth(state, data) {
      data = data.map(item => {
        return {
          ...item,
          date: moment(item.date).format('DD/MM/YYYY'),
          // Tính toán suất ăn tính tiền
          chargeAmount: max([item.regisAmount, item.amount]) - item.cancelAmount
        }
      })
      state.detailStudentMealReportByMonth = data
    }
  },
  getters: {}
}
